// @ts-check
/// <reference path="..\Scripts\s-pankki\Accessibility.js" />
/// <reference path="..\node_modules/highcharts/highstock.js" />
/// <reference path="..\node_modules/highcharts/modules/accessibility.js" />
/// <reference path="..\node_modules/highcharts/modules/data.js" />

// Initialize the graph
var investmentProductGraph;

// If a comparison product is selected from the dropdown,
// set it as the second series for the graph
$(document.body).on("click", ".comparison-dropdown-menu a", function (event) {
    event.stopPropagation();
    var selectedComparison = $(event.currentTarget);

    // Close the Bootstrap dropdown (toggle it)
    selectedComparison.closest(".comparison-select-container")
        .find("#comparison-dropdown-label")
        .text(selectedComparison.text())
        .end()
        .children(".dropdown-toggle")
        .dropdown("toggle");

    // If there was a previous comparison, remove it first from the series array
    if (investmentProductGraph.series.length > 1) {
        investmentProductGraph.series[1].remove();
    }

    var comparisonIsin = selectedComparison.data("isin");

    if (comparisonIsin !== "none") {
        var comparisonColor = selectedComparison.data("color");
        var comparisonIsBenchmark = false;
        var comparisonIsinInPath = comparisonIsin;

        if (investmentProductLang === "sv") {
            comparisonIsBenchmark = selectedComparison.text().includes("index");
        }
        else {
            comparisonIsBenchmark = selectedComparison.text().includes("indeksi");
        }

        var pathToGetComparisonGraphData = "/graphdata/";

        if (comparisonIsBenchmark) {
            pathToGetComparisonGraphData = "/benchmarkgraphdata/";
            comparisonIsinInPath = investmentProductIsin;
        }

        // Fetch the data for the comparison graph and add it as the second series
        $.getJSON("/" + investmentProductLang + "/api/" + investmentProductApiPath + pathToGetComparisonGraphData + comparisonIsinInPath, function (data) {
            investmentProductGraph.addSeries({
                name: data.name,
                data: data.data,
                color: comparisonColor,
                id: "comparisonProductData",
                type: "area",
                tooltip: {
                    pointFormatter: function () {
                        // Comparison graph should always be shown with two decimals, as we cannot
                        // determine whether the values include earnings or not
                        var dataValue = this.y.toFixed(2).replace('.', ',');
                        var coloredDot = '<span style="color:' + this.series.color + ';">\u25CF</span> ';

                        return coloredDot + this.series.name + ": <b>" + dataValue + "</b>";
                    }
                },
                fillOpacity: 0
            });

            // Set compare mode to percent
            $(".units").removeClass("btn-primary");
            $("#units-percent").addClass("btn-primary");
            investmentProductGraph.yAxis[0].setCompare("percent");
        });
    }

    return false;
});

function zoomInvestmentProductGraph(period) {
    var now = new Date();
    var minDate = now;
    var min = minDate.getTime();
    var max = now.getTime();

    switch (period) {
        case "1m":
            // If the graph is empty for some reason, zoom all the way out first so we have data
            if (investmentProductGraph.series[0].points.length === 0) {
                investmentProductGraph.zoomOut();
            }

            // For one month scaling, show values all the way to the last value
            // in the main series and one month before that
            max = investmentProductGraph.xAxis[0].dataMax;
            minDate = new Date(max);
            minDate.setMonth(minDate.getMonth() - 1);
            min = minDate.getTime();
            break;
        case "3m":
            // If the graph is empty for some reason, zoom all the way out first so we have data
            if (investmentProductGraph.series[0].points.length === 0) {
                investmentProductGraph.zoomOut();
            }

            // For three months scaling, show values all the way to the last value
            // in the main series and three months before that
            max = investmentProductGraph.xAxis[0].dataMax;
            minDate = new Date(max);
            minDate.setMonth(minDate.getMonth() - 3);
            min = minDate.getTime();
            break;
        case "6m":
            // If the graph is empty for some reason, zoom all the way out first so we have data
            if (investmentProductGraph.series[0].points.length === 0) {
                investmentProductGraph.zoomOut();
            }

            // For six months scaling, show values all the way to the last value
            // in the main series and six months before that
            max = investmentProductGraph.xAxis[0].dataMax;
            minDate = new Date(max);
            minDate.setMonth(minDate.getMonth() - 6);
            min = minDate.getTime();
            break;
        case "1y":
            // If the graph is empty for some reason, zoom all the way out first so we have data
            if (investmentProductGraph.series[0].points.length === 0) {
                investmentProductGraph.zoomOut();
            }

            // For one year scaling, show values all the way to the last value
            // in the main series and one year before that
            max = investmentProductGraph.xAxis[0].dataMax;
            minDate = new Date(max);
            minDate.setFullYear(minDate.getFullYear() - 1);
            min = minDate.getTime();
            break;
        case "3y":
            // If the graph is empty for some reason, zoom all the way out first so we have data
            if (investmentProductGraph.series[0].points.length === 0) {
                investmentProductGraph.zoomOut();
            }

            // For three years scaling, show values all the way to the last value
            // in the main series and three years before that
            max = investmentProductGraph.xAxis[0].dataMax;
            minDate = new Date(max);
            minDate.setFullYear(minDate.getFullYear() - 3);
            min = minDate.getTime();
            break;
        case "10y":
            // If the graph is empty for some reason, zoom all the way out first so we have data
            if (investmentProductGraph.series[0].points.length === 0) {
                investmentProductGraph.zoomOut();
            }

            // For ten years scaling, show values all the way to the last value
            // in the main series and ten years before that
            max = investmentProductGraph.xAxis[0].dataMax;
            minDate = new Date(max);
            minDate.setFullYear(minDate.getFullYear() - 10);
            min = minDate.getTime();
            break;
        case "max":
            min = 0;
    }

    if (min <= 0) {
        investmentProductGraph.zoomOut();
    }
    else {
        investmentProductGraph.xAxis[0].setExtremes(min, max);

        // Set the graph to begin from the first visible data point after zooming;
        // check that the value is within the given scaling
        if (investmentProductGraph.series[0].points.length !== 0) {
            var firstValueShownOnGraph = investmentProductGraph.series[0].processedXData[0];
            var minValueToSet = firstValueShownOnGraph;

            var secondValueShownOnGraph = investmentProductGraph.series[0].processedXData[1];
            var secondValueShownAsDate = new Date(secondValueShownOnGraph);

            var differenceBetweenFirstShownValueAndMin = Math.abs(firstValueShownOnGraph - min);
            var differenceBetweenSecondShownValueAndMin = Math.abs(secondValueShownOnGraph - min);
            var sevenDaysInMilliseconds = 1000 * 60 * 60 * 24 * 7;

            if (secondValueShownAsDate.toDateString() === minDate.toDateString()
                || ((differenceBetweenFirstShownValueAndMin > sevenDaysInMilliseconds)
                    && differenceBetweenSecondShownValueAndMin < differenceBetweenFirstShownValueAndMin)) {
                minValueToSet = secondValueShownOnGraph;
            }

            investmentProductGraph.xAxis[0].setExtremes(minValueToSet, max);
        }
    }
};

$("button.zoom").on("click", function () {
    $(".zoom").removeClass("btn-primary");
    $(this).addClass("btn-primary");
    var zoomPeriod = $(this).data("zoom");

    zoomInvestmentProductGraph(zoomPeriod);
});

 // Switch compare mode (none, percent) with buttons
$("button.units").on("click", function () {
    $(".units").removeClass("btn-primary");
    $(this).addClass("btn-primary");

    var compare = $(this).data("compare");

    // Current Highcharts version 11.0.1 has a bug with setting compare to none
    // if the chart has dataGrouping options defined,
    // so this doesn't work and we have to directly set the compare for each series
    //investmentProductGraph.yAxis[0].setCompare(compare);

    investmentProductGraph.series[0].update({
        compare: compare
    });

    if (investmentProductGraph.series.length > 1) {
        investmentProductGraph.series[1].update({
            compare: compare
        });
    }
});

var getInvestmentProductGraphTranslations = function (lang) {
    if (lang === "sv") {
        return {
            months: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],
            shortMonths: ["jan", "feb", "mars", "apr", "maj", "juni", "juli", "aug", "sept", "okt", "nov", "dec"],
            weekdays: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
            decimalPoint: ",",
            thousandsSep: ".",
            loading: "Laddar...",
            viewFullscreen: "Visa i helskärm",
            exitFullscreen: "Avsluta helskärmsläge",
            printChart: "Skriv ut diagram",
            downloadPNG: "Ladda ner PNG-bild",
            downloadJPEG: "Ladda ner JPEG-bild",
            downloadPDF: "Ladda ner PDF-dokument",
            downloadSVG: "Ladda ner SVG-vektorbild",
            downloadCSV: "Ladda ner CSV",
            downloadXLS: "Ladda ner XLS",
            viewData: "Visa datatabell",
            hideData: "Dölj datatabell",
            dateTime: "Datum"
        };
    }
    else {
        return {
            months: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kes\u00e4kuu", "hein\u00e4kuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"],
            shortMonths: ["tam", "hel", "maa", "huh", "tou", "kes", "hei", "elo", "syy", "lok", "mar", "jou"],
            weekdays: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"],
            decimalPoint: ",",
            thousandsSep: ".",
            loading: "Ladataan...",
            viewFullscreen: "Katso koko näytöllä",
            exitFullscreen: "Poistu koko näytön tilasta",
            printChart: "Tulosta kaavio",
            downloadPNG: "Lataa PNG",
            downloadJPEG: "Lataa JPEG",
            downloadPDF: "Lataa PDF",
            downloadSVG: "Lataa SVG",
            downloadCSV: "Lataa CSV",
            downloadXLS: "Lataa XLS",
            viewData: "Näytä taulukko",
            hideData: "Piilota taulukko",
            dateTime: "Päivämäärä"
        }
    }
};

var getInvestmentProductGraphWeekStartingTranslations = function (lang) {
    if (lang === "sv") {
        return "<b>Veckan</b> från %A %d.%m.%Y";
    }
    else {
        return "<b>Viikko</b> alkaen %A %d.%m.%Y";
    }
};

//Checks for the page type
var isObligationPage = document.querySelector('.obligation-page') !== null;

// Set Highcharts options
Highcharts.setOptions({
    // First color is for the main series, others are for comparison series
    colors: ["#008035", "#439fbb", "#ab89b7", "#fd9fbb", "#d06079", "#ff0066", "#eeaaee",
        "#55BF3B", "#DF5353", "#7798BF", "#aaeeee"],
    chart: {
        backgroundColor: null,
        style: {
            fontFamily: "S Bonus UX, sans-serif"
        }
    },
    title: {
        text: null
    },
    legend: {
        enabled: false
    },
    xAxis: {
        // Set xAxis min range to one week (this is the minimum interval to which the data can be zoomed)
        minRange: 1000 * 60 * 60 * 24 * 7,
        type: "datetime",
        title: {
            text: getInvestmentProductGraphTranslations(investmentProductLang).dateTime,
            enabled: undefined
        },
        labels: {
            style: {
                color: "#666666",
                fontSize: "11px"
            }
        },
        lineWidth: 2,
        lineColor: "#E6E6E6",
        tickColor: "#E6E6E6"
    },
    yAxis: {
        labels: {
            style: {
                color: "#666666"
            },
            formatter: function () {
                var formattedValue = parseFloat(this.value.toFixed(2)).toString().replace('.', ',');
                // Show units on the y-axis based on selected compare mode (different settings for obligations)
                var compare = this.axis.series[0].userOptions.compare || "none";
                if (isObligationPage) {
                    return formattedValue + { none: " %", value: " %", percent: " %" }[compare];
                }
                else {
                    return formattedValue + { none: " €", value: " €", percent: " %" }[compare];
                }                               
            }
        },
        gridLineWidth: 1,
        gridLineColor: "#E6E6E6"
    },
    tooltip: {
        xDateFormat: "%A %d.%m.%Y",
        split: false,
        pointFormatter: function () {
            // The start date for showing four decimals is 16.1.2021, i.e. 1610755200000
            var startDateForFourDecimals = 1610755200000;
            var dataValue = this.y;

            if (investmentProductHasEarnings === 'True' || this.x < startDateForFourDecimals || isObligationPage) {
                dataValue = this.y.toFixed(2).replace('.', ',');
            }
            else {
                dataValue = this.y.toFixed(4).replace('.', ',');
            }

            var coloredDot = '<span style="color:' + this.series.color + ';">\u25CF</span> ';

            return coloredDot + this.series.name + ": <b>" + dataValue + "</b>";
        }
    },
    plotOptions: {
        series: {
            compareStart: true,
            shadow: true,
            lineWidth: 2,
            dataGrouping: {
                approximation: function (groupData) {
                    return groupData[groupData.length - 1];
                },
                dateTimeLabelFormats: {
                    day: ["%A %d.%m.%Y"],
                    week: [getInvestmentProductGraphWeekStartingTranslations(investmentProductLang)],
                    month: ["%B %Y"],
                    year: ["%Y"]
                }
            }
        }
    },

    // Highstock specific
    rangeSelector: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    navigator: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    exporting: {
        menuItemDefinitions: {
            viewFullscreen: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).viewFullscreen
            },
            printChart: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).printChart
            },
            downloadPNG: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).downloadPNG
            },
            downloadJPEG: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).downloadJPEG
            },
            downloadPDF: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).downloadPDF
            },
            downloadSVG: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).downloadSVG
            },
            downloadCSV: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).downloadCSV
            },
            downloadXLS: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).downloadXLS
            },
            viewData: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).viewData
            },
            hideData: {
                text: getInvestmentProductGraphTranslations(investmentProductLang).hideData
            }
        }
    },

    lang: getInvestmentProductGraphTranslations(investmentProductLang)
});

$(function () {
    if (includeComparisons === "True") {
        // Colors for the comparisons
        var investmentProductColors = ["#439fbb", "#ab89b7", "#fd9fbb", "#d06079",
            "#ff0066", "#eeaaee", "#55BF3B", "#DF5353", "#7798BF", "#aaeeee",
            "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80",
            "#e4d354", "#8085e8", "#8d4653", "#91e8e1"];

        // Create comparison list dropdown for graph
        $.getJSON("/" + investmentProductLang + "/api/" + investmentProductApiPath + "/comparisondata/" + investmentProductIsin, function (data) {
            data.forEach(function (item, index) {
                var color = investmentProductColors[index % investmentProductColors.length];
                var id = item.isin;
                var name = item.name;

                // Use idnotation as identifier if set
                if (typeof item.idnotation !== "undefined") {
                    id = item.idnotation;
                }

                if (name === "null") {
                    name = "[unknown]";
                }

                $("#comparison-dropdown-menu-list").append(
                    $("<a/>", {
                        "class": "dropdown-item",
                        "data-isin": id,
                        "data-color": color,
                        "href": "#",
                        html: name
                    })
                );
            });
        });
    }
    
    // Draw the graph, with the selected investment product as the main series
    $.getJSON("/" + investmentProductLang + "/api/" + investmentProductApiPath + "/graphdata/" + investmentProductIsin, function (data) {
        investmentProductGraph = Highcharts.stockChart("investment-product-graph-container", {
            series: [{
                name: data.name,
                data: data.data,
                id: "investmentProductData",
                type: "area",
                threshold: null,
                fillOpacity: 0.1
            }]
        });

        // Funds with earnings are only shown the percent compare mode
        if (investmentProductHasEarnings === "True") {
            investmentProductGraph.yAxis[0].setCompare("percent");
        }
    });
});

//# sourceMappingURL=investmentproductgraph.js.map
